import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import { MultiSelectContext } from 'App/components/MultiselectProvider/MultiselectProvider';
import { openMultiUpdateActivity } from 'App/components/MultiActionModal/MultiUpdateActivity/openMultiUpdateActivity';
import planPhonecalls from './planPhonecalls';
import planTodos from './planTodos';
import { executeSave } from 'Helpers/multiModals';
import { CustomFieldWithValue } from 'App/resources/Model/CustomField';

interface UpdateTasksOptions {
	customerId: number;
	filters: RequestBuilder;
	entity: string;
	multiSelect: MultiSelect;
	isTodoList: boolean;
	isTodo: boolean;
}

export default function updateTasks(
	rb: RequestBuilder,
	entity: string,
	multiSelectContext: MultiSelectContext,
	isTodo: boolean = false
) {
	// Check if the new drawer implementation should be used
	const useDrawer = Tools.FeatureHelper.hasSoftDeployAccess('TODO_LIST');
	if (useDrawer) {
		const onSave = (properties: any, customFields?: CustomFieldWithValue[]) => {
			return new Promise(resolve => {
				executeSave({
					scope: {
						saving: false,
						resolve: (value?: any) => {
							// This triggers the ListView to refresh data
							resolve(value);
						},
						customFields: customFields
					},
					modalParams: {
						filters: rb,
						multiselect: multiSelectContext
					},
					multiSelect: {
						selected: multiSelectContext.selectedIds,
						selectNone: () => {}
					},
					entityType: isTodo ? 'Todo' : 'Activity',
					method: 'updateActivity',
					arrayProperties: [],
					scopeProperties: properties
				});
			});
		};

		if (isTodo) {
			return new Promise(resolve => {
				planTodos(rb, entity, multiSelectContext.selected, multiSelectContext.selectedIds, {
					onSave: (properties: any, customFields?: CustomFieldWithValue[]) => {
						return onSave(properties, customFields).then(resolve);
					},
					includes: ['activities', 'appointments'],
					isUpdateTodos: true
				});
			});
		}

		return new Promise(resolve => {
			planPhonecalls(rb, entity, multiSelectContext.selected, multiSelectContext.selectedIds, {
				onSave: (properties: any, customFields?: CustomFieldWithValue[]) => {
					return onSave(properties, customFields).then(resolve);
				},
				includes: ['activities', 'appointments'],
				isUpdateCalls: true
			});
		});
	}

	// Fall back to original modal implementation
	const multiSelect = {
		active: multiSelectContext.active,
		allSelected: multiSelectContext.allSelected,
		selected: multiSelectContext.selected,
		selectedIds: multiSelectContext.selectedIds,
		selectedIdMap: multiSelectContext.selectedIdMap
	};
	const opts: UpdateTasksOptions = {
		customerId: Tools.AppService.getCustomerId(),
		filters: rb,
		entity,
		multiSelect,
		isTodoList: true,
		isTodo: isTodo
	};

	return openMultiUpdateActivity(opts);
}
